import { render, staticRenderFns } from "./OBooleanButton.vue?vue&type=template&id=5fd5e0b6&scoped=true&"
import script from "./OBooleanButton.vue?vue&type=script&lang=js&"
export * from "./OBooleanButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5e0b6",
  null
  
)

export default component.exports